import React from 'react'
import "./Career_banner.css"

function Career_banner() {
  return (
  <>
    <section className="career-banner">
       <div className='banner_img_holder'>
            <img src="/assets/images/career/Career_banner/banner.png" alt="Career Banner" className='career-banner-img' />
       </div>
    </section>
  </>
  )
}

export default Career_banner